import type { IconData } from '@stacksjs/iconify-core'

export const heartRatePulseGraphSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.925 14.91c2.16-9.743 14.086-13.763 21.561-7.191c.174.151.346.314.513.48c.168-.166.34-.329.514-.48c7.474-6.572 19.4-2.552 21.56 7.19c1.491 6.347-1.033 11.768-4.758 16.202c-3.695 4.4-8.74 8.035-12.714 10.897l-.027.02a7.84 7.84 0 0 1-9.149 0l-.027-.02c-3.974-2.862-9.02-6.497-12.715-10.897C2.96 26.677.435 21.256 1.925 14.91m29.902-1.722a2 2 0 0 0-3.7.11l-4.24 11.305l-3.546-8.382a2 2 0 0 0-3.57-.229L13.852 21H8.998a2 2 0 0 0 0 4h6a2 2 0 0 0 1.728-.992l1.487-2.55l3.943 9.322a2 2 0 0 0 3.715-.078l4.284-11.424l2.016 4.535A2 2 0 0 0 33.999 25h5a2 2 0 0 0 0-4h-3.7z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default heartRatePulseGraphSolid
